import { configureStore } from '@reduxjs/toolkit';
import favouritesReducer from '../Providers/favouritesProvider';
import itemsReducer from './itemsSlice';
import addressReducer from './addressSlice';
import cartItemsReducer from '../Providers/cartProvider';
import ordersReducer from './orderSlice';
import authReducer from './authSlice';

 const store = configureStore({
  reducer: {
    favourites: favouritesReducer,
    items: itemsReducer, 
    address: addressReducer,  // Add the addressReducer here
    cartItems:cartItemsReducer,
    orders: ordersReducer, // Make sure 'orders' is correctly registered
    auth:authReducer,
  },
});
 
export default store;